import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-dot',
  templateUrl: './dot.component.html',
  styleUrls: ['./dot.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'color + " " + size',
  },
})
export class DotComponent {
  @Input() public color: 'unread' | 'notifications' | 'active' | 'archived';
  @Input() public size: 'small' | 'medium';
}
